import React from 'react';
import { useFormContext, UseFormReturn } from 'react-hook-form';
import {
  FLEX_DIRECTION,
  FlexBox,
  Checkbox,
  CheckboxProps
} from '@monorepo/ui-kit';
import Control from '../Control';
import { TFormField } from '../../types';
import styles from './index.module.css';

type CheckboxGroupProps<TFormValues> = {
  elements: Array<Partial<CheckboxProps>>;
  direction?: FLEX_DIRECTION;
} & TFormField<TFormValues>;

const CheckboxGroupField = <
  TFormValues extends Record<string, any> = Record<string, any>
>({
  id,
  name,
  label,
  className = '',
  elements,
  inputClassName,
  rules,
  disabled,
  direction = FLEX_DIRECTION.column
}: CheckboxGroupProps<TFormValues>) => {
  const { register }: UseFormReturn<TFormValues> =
    useFormContext<TFormValues>();

  const inputClass = `${
    direction ? styles[`${direction}Input`] : ''
  } ${inputClassName}`;

  return (
    <Control id={id} name={name} label={label} className={className}>
      <FlexBox direction={direction}>
        {elements?.map((el) => (
          <Checkbox
            id={el.id || `${name}.${el.value}`}
            key={el.id || `${name}.${el.value}`}
            label={el.label}
            value={el.value}
            className={inputClass}
            disabled={disabled || el.disabled}
            {...register(name, { ...rules })}
          />
        ))}
      </FlexBox>
    </Control>
  );
};

export default CheckboxGroupField;
